import React, { Component } from 'react'
import axios from 'axios/index'
import { APIURL, WEBURL } from '../../../config/config'
import * as moment from 'moment';
import 'moment/locale/th';

class CustomerFindCarBySale extends Component {
  constructor (props) {
    super(props)
    this.state = {
      customer_find_car_lists: [],
    }
  }

  componentDidMount () {
    var user = this.props.sale.user
    if(user!==''){
      this.getAllCustomerFindCarByUser(user)
    }
  }

  componentWillReceiveProps(nextProps) {

    var user = nextProps.sale.user
    var id = nextProps.sale.id

    if(user==='' && id==='') {
      this.setState({
        customer_find_car_lists: [],
      });
    } else if(nextProps.sale.id === this.props.saleId) {
      this.getAllCustomerFindCarByUser(user)
    }

  }

  getAllCustomerFindCarByUser(username) {
    let url = APIURL + '/customer_find_car/sale/'+username

    axios.get(url)
      .then(res => {
        this.setState({customer_find_car_lists: res.data})
      }).catch(error => {
      this.setState({customer_find_car_lists: []})
    })
  }

  render () {
    let customerFindCarLists = this.state.customer_find_car_lists.map((findCar, index) => {
      return (
        <div key={index}>
          <span className="badge bg-warning">หารถ {findCar.customer_find_car_id} </span>
          &nbsp;&nbsp;
          ชื่อ-นามสกุล: {findCar.customer_name} {findCar.customer_lastname} &nbsp; ({findCar.customer_mobile}) &nbsp; จาก {findCar.source_customer}
          &nbsp; &nbsp;<i className="icon-clock"></i> {moment(findCar.contact_date).locale('th').format('DD-MM-YYYY')}<br/>
          <div>หารถ : &nbsp;
            <span className="text-danger">
               {findCar.car_brand_name}&nbsp;
               {findCar.car_model_name}&nbsp;
               {findCar.car_gear_name}&nbsp;
               สี{findCar.car_color_name}&nbsp;
               ปี {findCar.car_year_start_name}-{findCar.car_year_final_name}
            </span>
          </div>
          <div>
            <CustomerFindCarTarget
              {...findCar}
            />
          </div>
        </div>
      )
    });
    return (
      <div className={this.state.customer_find_car_lists.length===0? "hidden" : ""}>
        <div className="row" style={{marginTop: 8}}>
          <div className="col-md-12">
            <h5>ลูกค้าหารถ</h5>
          </div>
        </div>
        <div className="row" style={{marginTop: 8}}>
          <div className="col-12">
            {customerFindCarLists}
          </div>
        </div>
      </div>
    )
  }
}

class CustomerFindCarTarget extends Component{
  constructor (props) {
    super(props)
    this.state = {
      car_targets: []
    }
    this._isMounted = false
    this.loadCarTarget = this.loadCarTarget.bind(this)
  }

  componentDidMount() {
    this._isMounted = true
    this._isMounted && this.loadCarTarget()
  }

  componentWillUnmount() {
    this._isMounted = false
  }

  async loadCarTarget() {
    let car_brand_id = this.props.car_brand_id
    let car_model_id = this.props.car_model_id
    let car_color_id = this.props.car_color_id
    let car_gear_id = this.props.car_gear_id
    let car_year_start_id  = this.props.car_year_start_id
    let car_year_final_id  = this.props.car_year_final_id
    let data = {
      car_brand_id: car_brand_id,
      car_model_id: car_model_id,
      car_color_id: car_color_id,
      car_gear_id: car_gear_id,
      car_year_start_id: Number(car_year_start_id),
      car_year_final_id: Number(car_year_final_id)
    }
    let url = APIURL + '/customer_find_car/target'
    let result = await axios.post(url, data)

    this._isMounted && this.setState({car_targets: result.data})
  }

  render() {
    let carTarget = this.state.car_targets.map((car, index) => {
      return (
        <div key={index}>
          <button className="btn-outline-warning"
                  onClick={()=>{
                    var urlOpen = WEBURL+'#/cars/detail/?car_id='+car.car_id+'&upload_code='+car.car_upload_code
                    window.open(urlOpen, "_blank")
                  }}
          > พบรถ : ดูรายละเอียด </button>
          &nbsp;&nbsp;
          {car.car_name} &nbsp; ทะเบียน {car.car_license_plate_new } &nbsp;&nbsp;
        </div>
      )
    })
    return (
      <div className={this.state.car_targets.length === 0 ? "hidden" : "row"} style={{marginLeft: 32, marginBottom: 16}}>
        {carTarget}
      </div>
    );
  }
}

export default CustomerFindCarBySale